/**
 * Format currency amount.
 * @param {number} amount
 * @param {string} currency - 'INR' or 'USD'
 */
export function formatCurrency(amount, currency = 'INR') {
  const locale = currency === 'INR' ? 'en-IN' : 'en-US'
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)
}

/**
 * Format date for display.
 * @param {string|Date} date
 * @returns {string} e.g. "21 Mar 2026"
 */
export function formatDate(date) {
  if (!date) return ''
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

/**
 * Format date for input[type=date].
 * @param {string|Date} date
 * @returns {string} e.g. "2026-03-21"
 */
export function toInputDate(date) {
  if (!date) return ''
  const d = new Date(date)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/**
 * Invoice status → badge color class.
 */
export function statusBadgeClass(status) {
  const map = {
    DRAFT: 'badge-gray',
    APPROVED: 'badge-blue',
    SENT: 'badge-blue',
    PARTIAL: 'badge-yellow',
    PAID: 'badge-green',
    OVERDUE: 'badge-red',
    CANCELLED: 'badge-red',
    SUBMITTED: 'badge-yellow',
    REJECTED: 'badge-red',
    REIMBURSED: 'badge-green',
    APPLIED: 'badge-green',
    ACCEPTED: 'badge-green',
    DECLINED: 'badge-red',
    EXPIRED: 'badge-gray',
  }
  return map[status] || 'badge-gray'
}

/**
 * GST state codes.
 */
export const GST_STATES = [
  { code: 1, name: 'Jammu and Kashmir' }, { code: 2, name: 'Himachal Pradesh' },
  { code: 3, name: 'Punjab' }, { code: 4, name: 'Chandigarh' },
  { code: 5, name: 'Uttarakhand' }, { code: 6, name: 'Haryana' },
  { code: 7, name: 'Delhi' }, { code: 8, name: 'Rajasthan' },
  { code: 9, name: 'Uttar Pradesh' }, { code: 10, name: 'Bihar' },
  { code: 11, name: 'Sikkim' }, { code: 12, name: 'Arunachal Pradesh' },
  { code: 13, name: 'Nagaland' }, { code: 14, name: 'Manipur' },
  { code: 15, name: 'Mizoram' }, { code: 16, name: 'Tripura' },
  { code: 17, name: 'Meghalaya' }, { code: 18, name: 'Assam' },
  { code: 19, name: 'West Bengal' }, { code: 20, name: 'Jharkhand' },
  { code: 21, name: 'Odisha' }, { code: 22, name: 'Chhattisgarh' },
  { code: 23, name: 'Madhya Pradesh' }, { code: 24, name: 'Gujarat' },
  { code: 26, name: 'Dadra and Nagar Haveli and Daman and Diu' },
  { code: 27, name: 'Maharashtra' }, { code: 29, name: 'Karnataka' },
  { code: 30, name: 'Goa' }, { code: 31, name: 'Lakshadweep' },
  { code: 32, name: 'Kerala' }, { code: 33, name: 'Tamil Nadu' },
  { code: 34, name: 'Puducherry' }, { code: 35, name: 'Andaman and Nicobar Islands' },
  { code: 36, name: 'Telangana' }, { code: 37, name: 'Andhra Pradesh' },
  { code: 38, name: 'Ladakh' },
]
